import { useEffect, useState } from "react";

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

import { useTranslation } from "react-i18next";

import WOW from 'wowjs';

import images from "../../core/data/galeria.json"

export const GaleriaPage = () => {

    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        new WOW.WOW().init();
    }, []);

    return (
        <div>
            <section>
                <div className="hero-section position-relative banner-section gap-2">
                    <img className="icon wow fadeInUp" src="/assets/img/new/elemento.png" />
                    <h1 className="wow fadeInUp">{t("gallery")}</h1>
                    <img className="icon wow fadeInUp" src="/assets/img/new/elemento2.png" />
                </div>
            </section>
            <section className="section px-0">
                <div className="gallery" >
                    {images.map((img, i) => (
                        <div
                            key={i}
                            className="gallery-item wow fadeInLeft"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                setPhotoIndex(i);
                                setIsOpen(true);
                            }}
                        >
                            <img src={img.src} alt={img.alt} />
                        </div>
                    ))}
                </div>
            </section>
            {isOpen && (
                <Lightbox
                    mainSrc={images[photoIndex].src}
                    nextSrc={images[(photoIndex + 1) % images.length].src}
                    prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                    onCloseRequest={() => setIsOpen(false)}
                    onMovePrevRequest={() =>
                        setPhotoIndex((photoIndex + images.length - 1) % images.length)
                    }
                    onMoveNextRequest={() =>
                        setPhotoIndex((photoIndex + 1) % images.length)
                    }
                    enableZoom={false}
                    ariaHideApp={false}
                />
            )}
        </div>
    )
}